'use client';

import { useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../../../lib/constants';
import type { FilterValuesType } from '../use-product-listing-filters';
import type { SortOption } from '../use-product-listing-sort-state';
import type { ProductListingPageSettings } from './product-listing-types';
import { getProductListingProducts } from './use-product-listing-products';

export function usePrefetchProductListingProducts() {
  const queryClient = useQueryClient();

  const prefetchProductListingProducts = async ({
    slug,
    currentPage,
    sort,
    settings,
    filterValues,
  }: {
    slug: string;
    currentPage: number;
    sort: SortOption;
    settings: ProductListingPageSettings;
    filterValues?: FilterValuesType;
  }) => {
    await queryClient.prefetchQuery({
      queryKey: [
        QUERY_KEYS.PRODUCT_LISTING_PRODUCTS,
        slug,
        currentPage,
        sort,
        filterValues,
      ],
      queryFn: () =>
        getProductListingProducts({
          slug,
          currentPage,
          sort,
          settings,
          filterValues,
        }),
      staleTime: 30000, // Consider data fresh for 30 seconds
    });
  };

  return prefetchProductListingProducts;
}
